import {useEffect, useState} from "react";
import {mrbgStore} from "./mrbgRedux";
function MrbgHierarchicalList({listID,mode,hierarchicalListDir,hierarchicalListMaxDeep,setSortList,formStyle}){

  const
    [list,setList] = useState(mrbgStore.getState().mrbgVars[listID]||[]),
    [divAndis,setDivAndis] = useState(null),
    [x1,setX1] = useState(null);

  function drop(e,liAndis){

    var
      curList = JSON.parse(JSON.stringify(list)),
      newList;

    if( mode == 'SHD2' ){
      var x = window.getComputedStyle(document.getElementById(listID)).direction == 'rtl'? 40: -40;
      curList[divAndis].depth =
        ( hierarchicalListDir=='ltr' )?
        Math.round( (parseInt(curList[divAndis].depth))+(e.pageX-x1) / x ):
        Math.round( (parseInt(curList[divAndis].depth))+(x1-e.pageX) / x );
    }

    if( divAndis == liAndis )
      newList = curList;
    else{
      newList =
        ( divAndis > liAndis )?
          curList.slice(0,liAndis).
            concat(curList.slice(divAndis,divAndis+1)).
            concat(curList.slice(liAndis,divAndis)).
            concat(curList.slice(divAndis+1)):

          curList.slice(0,divAndis).
            concat(curList.slice(divAndis+1,liAndis)).
            concat(curList.slice(divAndis,divAndis+1)).
            concat(curList.slice(liAndis));
    }

    if( mode == 'SHD2' )
      newList.forEach((item,key)=>{
        var
          maxD =
            key==0?
            0: Math.min( parseInt(newList[key-1].depth)+1, parseInt(hierarchicalListMaxDeep)-1 );
        newList[key].depth = Math.max(Math.min(parseInt(item.depth),maxD), 0);
      })

    setList( newList );
  }
  function dragStart(e,andis){
    e.dataTransfer.setData('Text',e.target.id);
    setDivAndis( andis   );
    setX1      ( e.pageX );
  }

  useEffect(()=>{
    var
      sortInfo = [],
      parents  = [],
      counter = 0;

    list.map((currentItem,k)=>{

      var nextItem = list[k+1] || null;

      while( parents.length && currentItem.depth <= list[ parents[parents.length-1] ].depth ){
        sortInfo[ parents[parents.length-1] ].rgt = counter++;
        parents.pop();
      }

      sortInfo[k] = {
        id: currentItem.id,
        lft: counter++,
        rgt: '',
        depth: currentItem.depth
      };

      nextItem && currentItem.depth < nextItem.depth?
        parents.push( k ):
        sortInfo[k].rgt = counter++;
    });

    while( parents.length ){
      sortInfo[ parents[parents.length-1] ].rgt = counter++;
      parents.pop();
    }
    setSortList( JSON.stringify(sortInfo) )
  },[list])
  useEffect(()=>{
    mrbgStore.subscribe(()=>{
      setList( mrbgStore.getState().mrbgVars[listID]||[] )
    })
  },[]);

  return(
    <ul id={listID} className={`${formStyle.sortHierarchical} ${mode}`} data-dir={hierarchicalListDir || 'rtl'}>
      {
        list.map((li,k)=>{
          return(
            <li id={`${listID}Li${k}`} onDragOver={e=>e.preventDefault()} onDrop={e=>drop(e,k)}  key={k}>
              <div id={`${listID}Div${k}`} className={formStyle[`L${li.depth}`]} draggable="true" onDragStart={e=>dragStart(e,k)} title={li.label}>{li.label}</div>
            </li>
          )
        })
      }
    </ul>
  )
}
export default MrbgHierarchicalList;